
import { Link } from 'react-router-dom';

export default function MedicationTherapyConsultation() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
              <li>
                <Link to="/" className="text-gray-500 hover:text-gray-700 cursor-pointer">ホーム</Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li>
                <Link to="/health-support" className="text-gray-500 hover:text-gray-700 cursor-pointer">健康サポート</Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li className="text-gray-900">薬物療法相談</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-purple-50 to-blue-50 py-16">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/a03d58bf845b139647febda5d5c19b23.jpg"
            alt="薬物療法相談"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            薬物療法<span className="text-purple-600">相談</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            処方薬の効果、副作用、飲み合わせについて薬剤師が詳しく説明いたします
          </p>
        </div>
      </section>

      {/* Service Overview */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">安全で効果的な薬物療法をサポート</h2>
              <p className="text-lg text-gray-600 mb-8">
                複数の薬を服用している方、副作用が心配な方、薬の効果について疑問をお持ちの方に、
                薬剤師が専門知識を活かして詳しくご説明し、最適な薬物療法をサポートします。
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">薬の相互作用チェック</h3>
                    <p className="text-gray-600">複数の薬やサプリメントの飲み合わせを詳しく確認</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">副作用の早期発見</h3>
                    <p className="text-gray-600">症状から副作用の可能性を判断し、適切な対処法をアドバイス</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">服薬指導の最適化</h3>
                    <p className="text-gray-600">あなたの生活スタイルに合わせた服薬方法をご提案</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Pharmacist%20explaining%20medication%20effects%20and%20side%20effects%20to%20patient%2C%20detailed%20pharmaceutical%20consultation%20with%20medicine%20information%20sheets%2C%20professional%20healthcare%20discussion%20about%20drug%20therapy%2C%20modern%20pharmacy%20setting&width=500&height=600&seq=medication-consultation&orientation=portrait"
                alt="薬物療法相談"
                className="w-full max-w-md h-96 object-cover object-top rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Consultation Areas */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">相談内容</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-12 h-12 bg-red-50 text-red-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-medicine-bottle-line text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">薬の効果・作用機序</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• 薬がどのように効くのか</li>
                <li>• 効果が現れるまでの期間</li>
                <li>• 最大効果を得るための服用方法</li>
                <li>• 薬の種類と特徴の違い</li>
                <li>• ジェネリック医薬品について</li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-12 h-12 bg-orange-50 text-orange-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-alert-line text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">副作用・注意事項</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• よくある副作用とその対処法</li>
                <li>• 重篤な副作用の見分け方</li>
                <li>• 副作用が疑われる症状の相談</li>
                <li>• 服用中の注意点</li>
                <li>• 生活上の制限事項</li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-12 h-12 bg-yellow-50 text-yellow-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-links-line text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">薬の相互作用</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• 薬同士の飲み合わせ</li>
                <li>• サプリメントとの相互作用</li>
                <li>• 食品との相互作用</li>
                <li>• アルコールとの関係</li>
                <li>• 他科受診時の注意点</li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-12 h-12 bg-green-50 text-green-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-time-line text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">服薬タイミング</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• 最適な服薬時間</li>
                <li>• 食事との関係</li>
                <li>• 飲み忘れた時の対処法</li>
                <li>• 複数薬の服薬スケジュール</li>
                <li>• 生活リズムとの調整</li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-user-heart-line text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">個別化医療</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• 年齢に応じた薬物療法</li>
                <li>• 腎機能・肝機能と薬の関係</li>
                <li>• 妊娠・授乳期の薬物療法</li>
                <li>• 小児・高齢者への配慮</li>
                <li>• 体質に合わせた調整</li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-12 h-12 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-question-line text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">その他の相談</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• 薬の保存方法</li>
                <li>• 旅行時の薬の管理</li>
                <li>• 薬の廃棄方法</li>
                <li>• 医療費の相談</li>
                <li>• セカンドオピニオン</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Common Concerns */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">よくある相談事例</h2>
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-xl shadow-lg p-6 border border-red-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">複数の薬を飲んでいて心配</h3>
                <p className="text-gray-600 mb-4">
                  「内科、整形外科、眼科から薬をもらっているが、飲み合わせは大丈夫？」
                </p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-700">
                    <strong>薬剤師の対応：</strong>すべての薬を確認し、相互作用をチェック。
                    必要に応じて医師と連携し、薬の調整を提案します。
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-xl shadow-lg p-6 border border-orange-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">副作用かどうか判断したい</h3>
                <p className="text-gray-600 mb-4">
                  「薬を飲み始めてから体調が悪い。これは副作用？」
                </p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-700">
                    <strong>薬剤師の対応：</strong>症状と薬の関係を詳しく分析。
                    副作用の可能性を評価し、医師への相談をサポートします。
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-xl shadow-lg p-6 border border-green-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">薬の効果が感じられない</h3>
                <p className="text-gray-600 mb-4">
                  「処方された薬を飲んでいるが、症状が改善しない」
                </p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-700">
                    <strong>薬剤師の対応：</strong>服薬方法や生活習慣を確認。
                    効果を高める方法や医師への相談タイミングをアドバイスします。
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl shadow-lg p-6 border border-blue-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">サプリメントとの飲み合わせ</h3>
                <p className="text-gray-600 mb-4">
                  「健康のためにサプリを飲んでいるが、処方薬と一緒で大丈夫？」
                </p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-700">
                    <strong>薬剤師の対応：</strong>サプリメントの成分を確認し、
                    処方薬との相互作用をチェック。安全な摂取方法をご提案します。
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl shadow-lg p-6 border border-purple-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">妊娠中・授乳中の薬</h3>
                <p className="text-gray-600 mb-4">
                  「妊娠がわかったが、今飲んでいる薬は続けても大丈夫？」
                </p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-700">
                    <strong>薬剤師の対応：</strong>妊娠・授乳期の薬物使用について詳しく説明。
                    医師と連携し、安全な治療選択肢をご提案します。
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-xl shadow-lg p-6 border border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">高齢者の薬物療法</h3>
                <p className="text-gray-600 mb-4">
                  「高齢の親が多くの薬を飲んでいて、管理が大変」
                </p>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-700">
                    <strong>薬剤師の対応：</strong>高齢者に適した薬物療法を検討。
                    服薬管理の工夫や家族のサポート方法をアドバイスします。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Process */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">相談の流れ</h2>
          <div className="grid md:grid-cols-5 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">1</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">情報収集</h3>
              <p className="text-gray-600">お薬手帳、処方箋、サプリメントなどの情報を確認</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">2</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">症状確認</h3>
              <p className="text-gray-600">現在の症状や気になる点を詳しくお聞きします</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">3</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">専門的分析</h3>
              <p className="text-gray-600">薬学的知識に基づいて総合的に分析・評価</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">4</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">説明・提案</h3>
              <p className="text-gray-600">わかりやすく説明し、改善策をご提案</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">5</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">継続フォロー</h3>
              <p className="text-gray-600">必要に応じて継続的にサポート</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-purple-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">薬物療法について相談しませんか？</h2>
          <p className="text-xl text-purple-100 mb-8">
            専門薬剤師があなたの薬物療法を安全で効果的にサポートいたします
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/health-support"
              className="bg-white text-purple-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              健康サポートに戻る
            </Link>
            <Link 
              to="/"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-purple-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              ホームに戻る
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">健康サポート</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-consultation/health-checkup-explanation" className="hover:text-white cursor-pointer">健康診断結果解説</Link></li>
                <li><Link to="/health-consultation/lifestyle-disease-prevention" className="hover:text-white cursor-pointer">生活習慣病予防</Link></li>
                <li><Link to="/health-consultation/medication-therapy-consultation" className="hover:text-white cursor-pointer">薬物療法相談</Link></li>
                <li><Link to="/health-consultation/health-management-plan" className="hover:text-white cursor-pointer">健康管理計画</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/pharmacist-resources" className="hover:text-white cursor-pointer">専門リソース</Link></li>
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
